module.exports = __webpack_public_path__ + "img/octagon.bfb8c39a.svg";